/**
 * Página de Noticias
 * 
 * Página que muestra las últimas noticias y novedades de Liga ProKids
 */

import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Noticias = () => {
  // Scroll al top cuando se carga la página
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  // Estilos inline para asegurar que las secciones ocupen todo el ancho disponible
  const sectionStyle = {
    width: '100%',
    margin: 0,
    padding: '60px 0',
    boxSizing: 'border-box',
  };

  const containerStyle = {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    boxSizing: 'border-box',
  };

  return (
    <>
      {/* Hero Section */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          padding: '40px 0 30px 0',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            ...containerStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontSize: '3rem',
              fontWeight: '700',
              marginBottom: '4px',
              color: '#061156',
              lineHeight: '1.0',
            }}
          >
            📰 Noticias Liga ProKids
          </h1>
          <h2
            style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              marginBottom: '6px',
              color: '#4352A9',
              lineHeight: '1.1',
            }}
          >
            Mantente al día con todas las novedades
          </h2>
          <p
            style={{
              fontSize: '1.1rem',
              marginBottom: '0px',
              color: '#061156',
              lineHeight: '1.3',
              maxWidth: '600px',
            }}
          >
            Descubre las últimas noticias, eventos y novedades de Liga ProKids. Aquí encontrarás toda la información relevante sobre nuestras actividades y logros.
          </p>
        </div>
      </section>

      {/* Contenido Principal */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: 'white',
        }}
      >
        <div style={containerStyle}>
          <div
            style={{
              backgroundColor: '#F8F9FF',
              borderRadius: '20px',
              padding: '60px 40px',
              textAlign: 'center',
              border: '3px solid #4352A9',
              boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
            }}
          >
            <div style={{ marginBottom: '30px' }}>
              <span style={{ fontSize: '4rem' }}>🚧</span>
            </div>
            <h3
              style={{
                fontSize: '2rem',
                fontWeight: '700',
                color: '#061156',
                marginBottom: '20px',
              }}
            >
              Sección en Construcción
            </h3>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#4352A9',
                lineHeight: '1.6',
                marginBottom: '30px',
                maxWidth: '600px',
                margin: '0 auto 30px auto',
              }}
            >
              Estamos trabajando en traerte las mejores noticias y novedades de Liga ProKids. 
              Muy pronto podrás encontrar aquí toda la información sobre eventos, logros de nuestros jugadores, 
              nuevas funcionalidades y mucho más.
            </p>
            <div
              style={{
                display: 'flex',
                gap: '20px',
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
            >
              <Link
                to="/liga-prokids"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  backgroundColor: '#4352A9',
                  color: 'white',
                  borderRadius: '25px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  textDecoration: 'none',
                  boxShadow: '0 4px 15px rgba(67, 82, 169, 0.3)',
                  transition: 'all 0.3s ease',
                }}
              >
                📖 Conoce Liga ProKids
              </Link>
              <Link
                to="/propoints"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  borderRadius: '25px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  textDecoration: 'none',
                  boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
                  transition: 'all 0.3s ease',
                }}
              >
                ⭐ Sistema ProPoints™
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Próximamente */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
        }}
      >
        <div style={containerStyle}>
          <h2
            style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              marginBottom: '40px',
              textAlign: 'center',
              color: '#061156',
            }}
          >
            🔜 Próximamente
          </h2>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px',
            }}
          >
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '15px',
                padding: '30px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                border: '2px solid #E8ECFF',
              }}
            >
              <span style={{ fontSize: '3rem', display: 'block', marginBottom: '15px' }}>🏆</span>
              <h4 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#061156', marginBottom: '10px' }}>
                Logros Destacados
              </h4>
              <p style={{ fontSize: '1rem', color: '#666', lineHeight: '1.5' }}>
                Celebraremos los logros más importantes de nuestros jugadores y equipos
              </p>
            </div>
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '15px',
                padding: '30px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                border: '2px solid #E8ECFF',
              }}
            >
              <span style={{ fontSize: '3rem', display: 'block', marginBottom: '15px' }}>📅</span>
              <h4 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#061156', marginBottom: '10px' }}>
                Eventos Especiales
              </h4>
              <p style={{ fontSize: '1rem', color: '#666', lineHeight: '1.5' }}>
                Información sobre torneos especiales, eventos y actividades extraordinarias
              </p>
            </div>
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '15px',
                padding: '30px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                border: '2px solid #E8ECFF',
              }}
            >
              <span style={{ fontSize: '3rem', display: 'block', marginBottom: '15px' }}>🚀</span>
              <h4 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#061156', marginBottom: '10px' }}>
                Nuevas Funcionalidades
              </h4>
              <p style={{ fontSize: '1rem', color: '#666', lineHeight: '1.5' }}>
                Te mantendremos informado sobre las últimas mejoras y nuevas características
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Noticias;
